import React from 'react';
import PropTypes from 'prop-types';

import VerticalSpacer from '../../components_common/VerticalSpacer/VerticalSpacer';
import Wrapper from '../../components_common/Wrapper/Wrapper';
import BrowseDepartmentPair from './BrowseDepartmentPair';
import BrowseFooter from './BrowseFooter';
import { menUrlNewInSale, womenUrlNewInSale, kidsUrlNewInSale } from '../../helpers/routes';
import withCountryCode from '../RoutesHoc/RoutesHoc';

const BrowseTiles = ({ children, s3BasePath, buildUrlWithCountry }) => (
  <>
    <VerticalSpacer height="40px" />
    <Wrapper margin="0 35px 0 35px">{children}</Wrapper>
    <VerticalSpacer height="20px" />
    <Wrapper margin="0 5px 0 5px">
      <BrowseDepartmentPair
        s3BasePath={s3BasePath}
        department="women"
        leftUrl={buildUrlWithCountry(womenUrlNewInSale())}
        rightUrl={buildUrlWithCountry(womenUrlNewInSale(true))}
      />
      <VerticalSpacer height="20px" />
      <BrowseDepartmentPair
        s3BasePath={s3BasePath}
        department="men"
        leftUrl={buildUrlWithCountry(menUrlNewInSale())}
        rightUrl={buildUrlWithCountry(menUrlNewInSale(true))}
      />
      <VerticalSpacer height="20px" />
      <BrowseDepartmentPair
        s3BasePath={s3BasePath}
        department="kids"
        leftUrl={buildUrlWithCountry(kidsUrlNewInSale())}
        rightUrl={buildUrlWithCountry(kidsUrlNewInSale(true))}
      />
    </Wrapper>
    <VerticalSpacer height="33px" />
    <BrowseFooter />
    <VerticalSpacer height="40px" />
  </>
);

BrowseTiles.propTypes = {
  isDesktop: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
  buildUrlWithCountry: PropTypes.func.isRequired,
};

export default withCountryCode(BrowseTiles);
